import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useScrollRestore = (watchPaths = []) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = location.pathname;
    const locationState = location.state || {};

    if (watchPaths.includes(currentPath) && locationState.fromVehicleDetail) {
      const savedScrollY = sessionStorage.getItem(`scrollY:${currentPath}`);
      if (savedScrollY) {
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedScrollY, 10));

          // Clean up the state after scroll restoration
          navigate(currentPath, { replace: true, state: {} });
        }, 50); // Delay ensures render is complete
      }
    }
  }, [location, navigate, watchPaths]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      const currentPath = location.pathname;
      if (watchPaths.includes(currentPath)) {
        sessionStorage.setItem(
          `scrollY:${currentPath}`,
          window.scrollY.toString()
        );
      }
    };

    // Save scroll position before navigating
    return () => {
      handleBeforeUnload();
    };
  }, [location.pathname, watchPaths]);
};
